import { numberToFixedLength, toBase36 } from './regep-technical-resource.utils';

export function generateIdentifier(applicationId: number, resourceIndex: number, postcode: string): string {
  const clientSpecificPrefix = 'E2132201'; // TODO: extract to configuration
  const locationPart = 'DE' + postcode || '00000';
  const applicationDynamicPart = generateApplicationGuidPart(applicationId, resourceIndex, { fixedLength: 8 });
  const clientSpecificSuffix = '0060000001'; // TODO: extract to configuration
  return `${clientSpecificPrefix}${locationPart}${applicationDynamicPart}${clientSpecificSuffix}`;
}

function generateApplicationGuidPart(applicationId: number, index: number, options?: { fixedLength }): string {
  const indexPart = numberToFixedLength(index, 2);
  const decimalText = applicationId.toString() + indexPart;
  let base36Text = toBase36(parseInt(decimalText));
  if (options?.fixedLength) {
    const numberOfTrailingZeroes = options.fixedLength - base36Text.length;
    if (numberOfTrailingZeroes > 0) {
      base36Text = Array(numberOfTrailingZeroes).fill('0').join('') + base36Text;
    }
  }

  return base36Text;
}
